import { Share, Link } from 'lucide-react'
import { sharePost } from '@/lib/share'
import { useToast } from '@/components/common/Toast'

interface ShareButtonProps {
  postId: string
  authorUsername: string
  contentPreview: string
}

export function ShareButton({ postId, authorUsername, contentPreview }: ShareButtonProps) {
  const { toast } = useToast()
  const canShare = typeof navigator !== 'undefined' && 'share' in navigator

  const handleClick = async () => {
    try {
      const used = await sharePost(postId, authorUsername, contentPreview)
      if (!used) toast.success('Link copied!')
    } catch {
      // User cancelled or clipboard unavailable — do nothing
    }
  }

  return (
    <button
      type="button"
      aria-label="Share post"
      onClick={() => { void handleClick() }}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '7px 9px',
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        borderRadius: 'var(--radius-pill)',
        color: 'var(--text-muted)',
        transition: 'background var(--dur-fast) var(--ease-out)',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = 'color-mix(in srgb, var(--brand) 10%, transparent)' }}
      onMouseLeave={(e) => { e.currentTarget.style.background = 'none' }}
    >
      {canShare ? <Share size={16} /> : <Link size={16} />}
    </button>
  )
}
